interface Tab<T extends string> {
  value: T;
  label: string;
}

interface TabsProps<T extends string> {
  tabs: Tab<T>[];
  active: T;
  onChange: (value: T) => void;
  variant?: 'underline' | 'pill';
}

export function Tabs<T extends string>({ tabs, active, onChange, variant = 'underline' }: TabsProps<T>) {
  if (variant === 'pill') {
    return (
      <div style={{ display: 'inline-flex', backgroundColor: '#f3f4f6', borderRadius: '8px', padding: '3px', marginBottom: '24px', gap: '2px' }}>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            style={{
              padding: '6px 16px',
              fontSize: '14px',
              fontWeight: active === tab.value ? '600' : '400',
              color: active === tab.value ? '#111827' : '#6b7280',
              backgroundColor: active === tab.value ? '#ffffff' : 'transparent',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              boxShadow: active === tab.value ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
              outline: 'none',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div style={{ borderBottom: '1px solid #e5e7eb', marginBottom: '24px' }}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          style={{
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: active === tab.value ? '600' : '400',
            color: active === tab.value ? '#3b82f6' : '#6b7280',
            backgroundColor: 'transparent',
            border: 'none',
            borderBottom: active === tab.value ? '2px solid #3b82f6' : '2px solid transparent',
            cursor: 'pointer',
            transition: 'all 0.2s',
            outline: 'none',
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
